import React from "react";
import HomeNav from "../components/landingPage/HomeNav";
import HomeFooter from "../components/landingPage/HomeFooter";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <HomeNav />

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          <div className="bg-[#9F9CFF] p-6">
            <h1 className="text-2xl font-bold text-white">Privacy Policy</h1>
            <p className="text-white text-sm mt-2">
              Effective Date:{" "}
              <span className="font-semibold">26 April, 2025</span>
            </p>
          </div>

          <div className="p-6">
            <p className="text-gray-700 mb-6">
              TwoKey Innovative Tech LLP ("we," "our," or "us") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              use{" "}
              <span className="font-semibold text-[#5E5ADB]">
                TwoKey EDP (Enterprise Digital Playground)
              </span>
              , our SaaS platform designed for SMEs and enterprises.
            </p>

            <p className="text-gray-700 mb-8">
              By using TwoKey EDP, you consent to the data practices described
              in this policy.
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                1. Information We Collect
              </h2>
              <p className="text-gray-700 mb-3">
                We collect the following types of personal and usage data:
              </p>
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                  <span className="font-medium">
                    User-provided information:
                  </span>{" "}
                  Name, email address, organization name, and any other
                  information you provide during registration or support
                  interactions.
                </li>
                <li>
                  <span className="font-medium">OAuth-based access:</span> If
                  you integrate with Gmail or Google Drive, we request limited
                  access via Google's secure OAuth protocol. We do{" "}
                  <span className="italic">not</span> store your emails or
                  documents unless explicitly saved to our platform.
                </li>
                <li>
                  <span className="font-medium">Payment data:</span> Billing and
                  transaction information is handled securely through our
                  payment provider, Razorpay. We do not store any credit/debit
                  card information.
                </li>
                <li>
                  <span className="font-medium">Usage data:</span> Metadata
                  related to your activity on our platform (e.g., login times,
                  IP addresses, device information) to improve our service and
                  maintain security.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                2. How We Use Your Information
              </h2>
              <p className="text-gray-700 mb-3">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>Provide, operate, and maintain the TwoKey EDP platform</li>
                <li>Authenticate users and manage accounts</li>
                <li>Deliver customer support</li>
                <li>
                  Improve platform performance, security, and user experience
                </li>
                <li>Process payments and manage subscriptions</li>
                <li>
                  Communicate with you regarding product updates, system
                  notifications, or billing matters
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                3. Data Storage and Security
              </h2>
              <p className="text-gray-700">
                Your data is securely stored in{" "}
                <span className="font-medium">AWS India</span> servers and
                <span className="font-medium"> Google Firestore/Firebase</span>,
                with strict access control and encryption protocols in place. We
                follow industry best practices to protect your personal
                information from unauthorized access or disclosure.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                4. Third-Party Services
              </h2>
              <p className="text-gray-700 mb-3">
                We use trusted third-party providers solely for infrastructure
                and payments:
              </p>
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                  <span className="font-medium">Google APIs:</span> For Gmail
                  and Google Drive integration (read-only access where required)
                </li>
                <li>
                  <span className="font-medium">Razorpay:</span> For secure
                  payment processing
                </li>
                <li>
                  <span className="font-medium">Firebase/Firestore:</span> For
                  authentication and real-time data sync
                </li>
              </ul>
              <p className="text-gray-700 mt-3">
                These services are governed by their respective privacy
                policies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                5. Data Sharing and Disclosure
              </h2>
              <p className="text-gray-700 mb-3">
                We{" "}
                <span className="font-medium">do not sell, rent, or trade</span>{" "}
                your personal information. We may disclose your data:
              </p>
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                  To service providers under contract who help us operate the
                  platform
                </li>
                <li>
                  To comply with legal obligations or respond to lawful requests
                </li>
                <li>To protect our legal rights, users, or the public</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                6. Your Rights and Choices
              </h2>
              <p className="text-gray-700 mb-3">You have the right to:</p>
              <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>Access and update your personal information</li>
                <li>
                  Revoke Google integration access at any time via your Google
                  account settings
                </li>
                <li>Request deletion of your account and associated data</li>
              </ul>
              <p className="text-gray-700 mt-3">
                To exercise any of these rights, contact us at{" "}
                <a href="mailto:itstwokey@gmail.com">
                  <span className="font-medium text-[#5E5ADB] hover:underline">
                    itstwokey@gmail.com
                  </span>
                </a>
                .
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                7. Data Retention
              </h2>
              <p className="text-gray-700">
                We retain your information for as long as your account is active
                or as needed to comply with legal, tax, or regulatory
                obligations.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                8. Children's Privacy
              </h2>
              <p className="text-gray-700">
                TwoKey EDP is not intended for use by children under the age of
                18. We do not knowingly collect personal data from minors.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                9. Changes to This Policy
              </h2>
              <p className="text-gray-700">
                We may update this Privacy Policy from time to time. Any changes
                will be posted here, and your continued use of the service after
                such updates constitutes your agreement to the revised terms.
              </p>
            </section>

            <section className="mb-4">
              <h2 className="text-xl font-bold text-[#5E5ADB] mb-4">
                10. Contact Us
              </h2>
              <p className="text-gray-700">
                For questions or concerns about this policy, contact us at:
              </p>
              <div className="mt-2 text-gray-700">
                <p className="font-medium">TwoKey Innovative Tech LLP</p>
                <p>
                  Email:{" "}
                  <a href="mailto:itstwokey@gmail.com">
                    <span className="text-[#5E5ADB] hover:underline">
                      itstwokey@gmail.com
                    </span>
                  </a>
                </p>
                <p>
                  Address:{" "}
                  <span className="text-[#5E5ADB]">
                    B701 Marvel Sangria, NIBM rd Mohammed wadi, Pune,
                    Maharashtra.
                  </span>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <HomeFooter />
    </div>
  );
};

export default PrivacyPolicy;
